
import { useEffect } from 'react';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';
import HonorsHero from './components/HonorsHero';
import CertificationGrid from './components/CertificationGrid';
import AwardsTimeline from './components/AwardsTimeline';
import QualityAssurance from './components/QualityAssurance';

export default function Honors() {
  useEffect(() => {
    // 设置页面标题和meta信息
    document.title = '荣誉资质 - 马帮瑞贡官网';
    
    // 更新meta描述
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '马帮瑞贡荣誉资质展示，包括各项认证证书、获奖记录和质量保证体系，见证三百年品牌传承的卓越品质。');
    }

    // 更新meta关键词
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', '马帮瑞贡,荣誉资质,认证证书,获奖记录,质量保证,普洱茶品质');
    }

    // 添加Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "荣誉资质 - 马帮瑞贡官网",
      "description": "马帮瑞贡荣誉资质展示，包括各项认证证书、获奖记录和质量保证体系，见证三百年品牌传承的卓越品质。",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/honors`,
      "isPartOf": {
        "@type": "WebSite",
        "name": "马帮瑞贡官网",
        "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`
      },
      "about": {
        "@type": "Organization",
        "name": "马帮瑞贡",
        "award": [
          "中央政府采购供应商",
          "上海合作组织国宾伴手礼",
          "云南省著名商标",
          "普洱茶行业领军品牌"
        ]
      }
    });
    document.head.appendChild(script);

    return () => {
      // 清理
      const existingScript = document.querySelector('script[type="application/ld+json"]');
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HonorsHero />
        <div className="pt-16 lg:pt-20">
          <CertificationGrid />
          <AwardsTimeline />
          <QualityAssurance />
        </div>
      </main>
      <Footer />
    </div>
  );
}